import { useEffect, useState } from 'react';
import { config } from '../../features/auth/config';

export interface PublicSettings {
  businessName: string;
  supportPhone: string;
  supportWhatsappUrl: string;
  /** Signup bonus credits granted on registration (from internal settings). */
  signupBonusCredits: number;
}

/**
 * Fetches public app settings (no auth) from the internal settings store, so
 * marketing copy stays in sync with what admins configure (e.g. signup bonus).
 */
export function usePublicSettings() {
  const [settings, setSettings] = useState<PublicSettings | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${config.api.baseUrl}/api/settings/public`, {
          headers: {
            [config.auth.headers.frontendKey]: config.auth.headers.frontendKeyValue,
          },
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        const data = json.data || json;
        if (!cancelled) {
          setSettings({
            businessName: data.businessName || '',
            supportPhone: data.supportPhone || '',
            supportWhatsappUrl: data.supportWhatsappUrl || '',
            signupBonusCredits: Number(data.signupBonusCredits) || 0,
          });
          setLoading(false);
        }
      } catch {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return { settings, loading, signupBonusCredits: settings?.signupBonusCredits ?? null };
}
